import { render, staticRenderFns } from "./fees-paid.vue?vue&type=template&id=37fefa7c"
import script from "./fees-paid.vue?vue&type=script&lang=js"
export * from "./fees-paid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports